module.exports = __webpack_public_path__ + "img/071.c9f887af.png";